import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import { Input, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Add from '@material-ui/icons/Add';
import Minimize from '@material-ui/icons/Minimize';
import React from 'react';
import NumberFormat from 'react-number-format';
import { Fab } from '@material-ui/core';

var styles = function styles(theme) {
  return {
    row: {
      width: '100%',
      height: '33px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    actionButton: {
      height: '22px',
      minHeight: '22px',
      width: '22px',
      backgroundColor: 'rgba(0, 0, 0, 0)',
      boxShadow: 'none',
      borderStyle: 'solid',
      border: '1px ' + theme.palette.primary.main,
      '&:hover': {
        color: '#FFFFFF',
        backgroundColor: 'rgba(255, 130, 0, 0.08)'
      },
      '&:active': {
        boxShadow: 'none',
        backgroundColor: theme.palette.primary.main
      }
    },
    icon: {
      fontSize: '16px',
      color: theme.palette.primary.main
    },
    field: {
      width: '50px',
      textAlign: 'right',
      borderBottom: '0',
      marginRight: '4px',
      marginLeft: '4px'
    }
  };
};

function NumberFormatCustom(props) {
  var inputRef = props.inputRef,
      onChange = props.onChange,
      other = _objectWithoutProperties(props, ['inputRef', 'onChange']);

  return React.createElement(NumberFormat, _extends({}, other, {
    getInputRef: inputRef,
    onValueChange: function onValueChange(values) {
      onChange({
        target: {
          value: values.value
        }
      });
    }
  }));
}

var ValueControl =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ValueControl, _React$Component);

  function ValueControl() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ValueControl);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ValueControl)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.numberInput = function (value) {
      var _this$props = _this.props,
          onValueChange = _this$props.onValueChange,
          classes = _this$props.classes;
      return React.createElement(React.Fragment, null, React.createElement(Fab, {
        classes: {
          root: classes.actionButton
        },
        onClick: function onClick() {
          return onValueChange(Math.max(0, value - 1));
        }
      }, React.createElement(Minimize, {
        className: classes.icon,
        style: {
          marginTop: '-10px'
        }
      })), React.createElement(Input, {
        value: value,
        disableUnderline: true,
        onChange: function onChange(event) {
          var value = event.target.value;
          value = Number.parseInt(value);
          onValueChange(Number.isNaN(value) ? 0 : value);
        },
        inputComponent: NumberFormatCustom,
        inputProps: {
          style: {
            textAlign: 'right'
          }
        },
        className: classes.field
      }), React.createElement(Fab, {
        className: classes.actionButton,
        onClick: function onClick() {
          return onValueChange(Math.max(0, value + 1));
        }
      }, React.createElement(Add, {
        className: classes.icon
      })));
    }, _this.booleanInput = function (value) {
      var onValueChange = _this.props.onValueChange;
      return React.createElement(Switch, {
        color: 'primary',
        value: value,
        checked: value,
        onChange: function onChange(event) {
          return onValueChange(event.target.checked);
        }
      });
    }, _temp));
  }

  _createClass(ValueControl, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          label = _this$props2.label,
          value = _this$props2.value,
          classes = _this$props2.classes,
          inverted = _this$props2.inverted;
      return React.createElement('div', {
        className: classes.row
      }, !inverted && React.createElement(React.Fragment, null, React.createElement(Typography, null, label), React.createElement('div', null, typeof value === typeof 123 && this.numberInput(value), typeof value === typeof true && this.booleanInput(value))), inverted && React.createElement(React.Fragment, null, React.createElement('div', null, typeof value === typeof 123 && this.numberInput(value), typeof value === typeof true && this.booleanInput(value)), React.createElement(Typography, {
        style: {
          paddingLeft: '8px'
        }
      }, label)));
    }
  }]);

  return ValueControl;
}(React.Component);

export default withStyles(styles)(ValueControl);